export function configure(config) {
  config.globalResources([
    PLATFORM.moduleName('resources/attributes/tip'),
    PLATFORM.moduleName('resources/value-converters/date-format'),
    PLATFORM.moduleName('resources/value-converters/decimal-format'),
    PLATFORM.moduleName('resources/value-converters/number-format'),
    PLATFORM.moduleName('resources/attributes/mask')
  ]);
}
